import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import CheckboxGroup from 'components/Form/CheckboxGroup';
import Checkbox from 'components/Form/Checkbox';
import { CheckboxModel } from 'forms/shared/types';
import { ValidationElementProps } from '../../../Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonOnError, CommonRequired } from '../../../../types/props';
import { ErrorCode } from '../../../../redux/modules/application/reducers/error';
import { FinancialNonPaymentItemModel } from '../../../../forms/sections/financial/nonPayment/types';

interface Props
  extends Partial<FinancialNonPaymentItemModel['Infractions']>,
    ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired

  className?: string
  attribute?: string
}

export default class Infractions extends ValidationElement<Props> {
  update = (values: CheckboxModel) => {
    const selected = values.value;
    const list = [...(this.props.values || [])];

    if (list.includes(selected)) {
      list.splice(list.indexOf(selected), 1);
    } else {
      list.push(selected);
    }

    if (this.props.onUpdate) {
      this.props.onUpdate({
        name: this.props.name,
        values: list,
      });
    }
  };

  render() {
    return (
      <div>
        {i18n.m('financial.nonpayment.para.checkAll')}
        <CheckboxGroup
          className={`option-list option-list-vertical ${this.props.className || ''}`.trim()}
          selectedValues={this.props.values}
          attribute={this.props.attribute}
        >
          <Checkbox
            label={i18n.t('financial.nonpayment.para.repo')}
            value="Repossession"
            className="nonpayment-repossession"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.defaulted')}
            value="Defaulted"
            className="nonpayment-defaulted"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.collections')}
            value="Collections"
            className="nonpayment-collections"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.cancelled')}
            value="Cancelled"
            className="nonpayment-cancelled"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.evicted')}
            value="Evicted"
            className="nonpayment-evicted"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.garnished')}
            value="Garnished"
            className="nonpayment-garnished"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.delinquent')}
            value="Delinquent"
            className="nonpayment-delinquent"
            onUpdate={this.update}
            onError={this.props.onError}
          />
          <Checkbox
            label={i18n.t('financial.nonpayment.para.any')}
            value="Any"
            className="nonpayment-any"
            onUpdate={this.update}
            onError={this.props.onError}
          />
        </CheckboxGroup>
      </div>
    );
  }
}

Infractions.defaultProps = {
  values: [],
  onError: (value, arr: ErrorCode) => arr,
};
